export const FULLSTORY_MASK_CLASSNAME = 'fs-mask';

export const FS_CATEGORIES = {
  PAYMENT_SUBMIT: 'Payment Submit',
  IDV_SECURE: 'Idv SecureMe'
};

export const FS_ACTIONS = {
  FAILURE: 'Failure',
  SUCCESS: 'Success'
};

export const FS_LABEL = {
  PAYMENT_SUCCESS: 'Payment is successful',
  FORM_NOT_VALID: 'Form not valid'
};
